import { signal } from "@preact/signals-react";

export const adminProductReviewRawTableData = signal([])

export const AdminProductReviewRetailerSelected = signal([])

export const adminProductReviewItemClicked = signal(null)

export const adminProductReviewDetailsClicked = signal(null)

export const adminProductReviewEditClicked = signal(null)

export const adminProductReviewLoadingRow = signal([])

export const resetAdminProductReview = () => {
    adminProductReviewRawTableData.value = []
    AdminProductReviewRetailerSelected.value = []
    adminProductReviewItemClicked.value = null
    adminProductReviewDetailsClicked.value = null
    adminProductReviewEditClicked.value = null
    adminProductReviewLoadingRow.value = []
}